export const actions = {
  setTask: 'SET::SETTASK',
  getTask: 'GET::GETTASK'
}
export const setSiteTask = taskSelectedItems => ({ type: actions.setTask, taskSelectedItems })
export const getTask = state => state.task.taskSelectedItems

export default actions
